import React, {FormEvent, useEffect, useState} from 'react'
import queryString from "query-string";
import ReactGA from "react-ga";
import AlbumViewer from "../components/album-viewer";
import MediaItem from "../models/media-item";
import {AdsItem, AlbumInfo} from "../models/responses";
import {User} from "../types/user";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../reducers/root-reducer";
import {getAlbumInfo} from "../store/media-album-actions";

function AlbumViewerPage() {

    const images = useSelector<RootState, MediaItem[]>(s => s.albumState.media)
    const albumInfo = useSelector<RootState, AlbumInfo | undefined>(s => s.albumState.album_info)
    const users = useSelector<RootState, User[]>(s => s.albumState.users)
    const ads = useSelector<RootState, AdsItem[]>(s => s.albumState.ads)
    const albumLocked = useSelector<RootState, boolean>(s => s.albumState.isLocked)
    const [lockCode, setLockCode] = useState<string | undefined>(undefined)
    const currentUploadedItem = useSelector<RootState, File | undefined>(s => s.uploadFiles.fileProgress?.file)

    const dispatch = useDispatch()

    useEffect(() => {
        ReactGA.initialize('UA-145092517-1');
        ReactGA.pageview('/album_viewer');

        refreshAlbum()
    }, [])

    useEffect(()=>
        refreshAlbum()
    , [currentUploadedItem])

    function refreshAlbum(lockCode: string | undefined = undefined) {
        const params = queryString.parse(window.location.search);

        const link = params.link;

        if (typeof link == "string") {
            dispatch(getAlbumInfo(link, lockCode))
        }
    }

    function getImages(): MediaItem[] {
        let result: MediaItem[] = []
        images.forEach(function (m: MediaItem, i: number) {
            result.push(m)
            if ((i + 1) % 10 === 0 && ads.length > 0) {
                let ad = ads[i % ads.length]
                result.push({
                    id: 0,
                    media: ad.filename,
                    updated: "",
                    filename: ad.filename,
                    title: "",
                    thumbnail: ad.thumbnail,
                    type: "ads",
                    comments_count: 0,
                    likes_count: 0
                })
            }
        });

        return result
    }

    function tryWithLockCode(event: FormEvent<HTMLFormElement>) {
        if (lockCode) {
            refreshAlbum(lockCode)
        }
        event.stopPropagation()
        event.preventDefault()
    }

    return (
        <>
            {!albumLocked && albumInfo && <AlbumViewer images={getImages()} albumInfo={albumInfo} users={users}/>}
            {albumLocked &&
            <form onSubmit={tryWithLockCode}>
                <div className="gallery-container" id="lock_code_input">
                    <input type="text" name="lock_code" id="lock_code" placeholder="Lock code"
                           onChange={(e) => setLockCode(e.target.value)}/>
                    <button type="submit" style={{marginLeft: "10px", borderRadius: 5, padding: "0 10px"}}>Send</button>
                </div>
            </form>
            }
        </>
    )

}

export default AlbumViewerPage;
